import { GoogleMapsProduct } from "./map-products/google-map-product";
import { LeafletProduct } from "./map-products/leaflet-product";

export abstract class MapHandlerCreator {
    public map;

    constructor(map) {
        this.map = map;
    };

    public abstract factoryMethod(): Product;

    public newPoly() {
        return this.factoryMethod().newPoly();
    }
    public addPolyDestination(coords, index?: any) {
        return this.factoryMethod().addPolyDestination(coords, index);
    }
    public positionMarker(o) {
        return this.factoryMethod().positionMarker(o);
    }
    public flyTo(location) {
        return this.factoryMethod().flyTo(location);
    }
    public positionNearestCompetitors(competitor) {
        return this.factoryMethod().positionNearestCompetitors(competitor);
    }
    public setMapOnAll(map) {
        return this.factoryMethod().setMapOnAll(map);
    }
    public clearMarkers() {
        return this.factoryMethod().clearMarkers();
    }
    public showMarkers() {
        return this.factoryMethod().showMarkers();
    }
    public deleteMarkers() {
        return this.factoryMethod().deleteMarkers();
    }
    public setMapCenter(o, zoom?) {
        return this.factoryMethod().setMapCenter(o, zoom);
    }
    public setMapCenterLatLng(coords, zoom?) {
        return this.factoryMethod().setMapCenterLatLng(coords, zoom);
    }
    public setMap(map) {
        this.map = map;
    }
    public getMap() {
        return this.map;
    }
    public getCenter() {
        return this.factoryMethod().getCenter();
    }
    public setPolyDraw(isCustom: boolean = false) {
        return this.factoryMethod().setPolyDraw(isCustom);
    }
    public getPolyLines() {
        return this.factoryMethod().getPolyLines();
    }
    public drawPolyLines(isCustom: boolean = false) {
        return this.factoryMethod().drawPolyLines(isCustom);
    }
    public setPolyDestinations(o) {
        return this.factoryMethod().setPolyDestinations(o);
    }
    public getPolyDestinations() {
        return this.factoryMethod().getPolyDestinations();
    }
    public preloadMap(path): Promise<any> {
        return this.factoryMethod().preloadMap(path);
    }
    public drawStartFinishMarkersArray(coords, icons) {
        return this.factoryMethod().drawStartFinishMarkersArray(coords, icons);
    }
    public clearMeMarker() {
        return this.factoryMethod().clearMeMarker();
    }
    public drawStartFinishMarkersLatLng(coords, icons) {
        return this.factoryMethod().drawStartFinishMarkersLatLng(coords, icons);
    }

    public clearNearestMarkers() {
        return this.factoryMethod().clearNearestMarkers();
    }

    public disableZoom() {
        return this.factoryMethod().disableZoom();
    }

    public setMapCenterZoom(zoom) {
        return this.factoryMethod().setMapCenterZoom(zoom);
    }

    public removeAllPath() {
        return this.factoryMethod().removeAllPath();
    }
    public destroy(){
        this.map = null;
        return this.factoryMethod().destroy();
    }
}


export class GoogleMapsCreator extends MapHandlerCreator {
    constructor(map) {
        super(map);
    }

    public factoryMethod(): Product {
        return GoogleMapsProduct.getInstance(this.map);
    }
}

export class LeafletCreator extends MapHandlerCreator {
    constructor(map) {
        super(map);
    }

    public factoryMethod(): Product {
        return LeafletProduct.getInstance(this.map);
    }
}

/**
 * The Product interface declares the operations that must be performed by all specific products: google maps, leaflet 
 */
export interface Product {
    newPoly();
    addPolyDestination(coords, index?: any);
    positionMarker(o);
    flyTo(location)
    positionNearestCompetitors(competitor);
    setMapOnAll(map);
    clearMarkers();
    showMarkers();
    deleteMarkers();
    setMapCenter(o, zoom?);
    setMapCenterLatLng(coords, zoom);
    setMapCenterZoom(zoom);
    setMap(map);
    getMap();
    clearMeMarker();
    getCenter();
    setPolyDraw(isCustom);
    getPolyLines();
    drawPolyLines(isCustom: boolean);
    setPolyDestinations(o);
    getPolyDestinations();
    preloadMap(path);
    drawStartFinishMarkersLatLng(coords, icons);
    drawStartFinishMarkersArray(coords, icons);
    clearNearestMarkers();
    disableZoom();
    removeAllPath();
    destroy();
}



